// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34ca0fa6","732":"4ad11e31","977":"233dae47"}[chunkId] + ".chunk.js";
};